import type { ReactNode } from "react";

import { NavigationMenu, NavigationMenuList } from "../../../ui/navigation-menu";

export const NavLeft = ({
  logo,
  children,
}: {
  logo: ReactNode;
  children: ReactNode;
}) => {
  return (
    <div className="flex flex-row items-center">
      <div className="mr-6 lg:mr-12">{logo}</div>

      <NavigationMenu>
        <NavigationMenuList className="hidden lg:visible lg:flex">{children}</NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};
